export const BTN_CANCEL = "ABBRECHEN";
export const BTN_ACCEPT = "DOWNLOAD";